import { useTranslation } from 'react-i18next';

import { ScrollArea, LoadingSpinner } from '@app/shared/ui/atoms/Common';
import { TopBar, NotFound } from '@app/shared/ui/molecules/Common';
import { WithdrawalCards } from '@app/shared/ui/organisms/Withdrawal';
import { useGetMyWithdrawalQuery } from '@app/store/slices/withdrawal/withdrawalApi';
import { useDisplayError } from '@app/shared/hooks/useDisplayError';

export default function WithdrawalPage() {
  const { t } = useTranslation();

  const {
    data: withdrawal,
    isLoading: isWithdrawalLoading,
    isFetching: isWithdrawalFetching,
    isError: isWithdrawalError,
  } = useGetMyWithdrawalQuery();

  const failedToLoadWithdrawalMsg = t('errors.failed_to_load_withdrawal');
  useDisplayError(isWithdrawalError, failedToLoadWithdrawalMsg);

  const renderContent = () => {
    if (isWithdrawalLoading || isWithdrawalFetching) {
      return <LoadingSpinner size="lg" />;
    } else if (isWithdrawalError) {
      return <NotFound message={failedToLoadWithdrawalMsg} withLightBlueBg />;
    }

    return <WithdrawalCards withdrawal={withdrawal} />;
  };

  return (
    <ScrollArea>
      <TopBar />
      {renderContent()}
    </ScrollArea>
  );
}
